(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-featured-product] .featured-product__qty-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var input = this.closest('.featured-product__qty').querySelector('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (this.hasAttribute('data-qty-up')) {
      input.value = val + 1;
    } else if (this.hasAttribute('data-qty-down')) {
      if (val > 1) input.value = val - 1;
    }
  });
});
document.querySelectorAll('[data-featured-product] [data-featured-option]').forEach(function(input) {
  input.addEventListener('change', function() {
    var form = this.closest('.featured-product__form');
    if (!form) return;
    var formData = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of formData.entries()) {
      if (pair[0] !== 'id' && pair[0] !== 'quantity') {
        params.append(pair[0], pair[1]);
      }
    }
    params.append('view', 'featured-variant');
    fetch(window.location.pathname + '?' + params.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.id) {
          form.querySelector('input[name="id"]').value = data.id;
          var priceEl = form.closest('.featured-product__info').querySelector('[data-product-price]');
          if (priceEl) priceEl.textContent = data.price;
          var submitBtn = form.querySelector('[name="add"]');
          if (submitBtn) {
            if (data.available) {
              submitBtn.disabled = false;
              submitBtn.querySelector('.featured-product__submit-text').textContent = 'Add to Cart';
            } else {
              submitBtn.disabled = true;
              submitBtn.querySelector('.featured-product__submit-text').textContent = 'Sold Out';
            }
          }
        }
      });
  });
});
document.querySelectorAll('[data-featured-product] .featured-product__form').forEach(function(form) {
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = this.querySelector('[name="add"]');
    if (!btn || btn.disabled) return;
    var textEl = btn.querySelector('.featured-product__submit-text');
    btn.disabled = true;
    if (textEl) textEl.textContent = 'Adding\u2026';
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(data) {
        btn.disabled = false;
        if (textEl) textEl.textContent = 'Add to Cart';
        if (typeof showCartToast === 'function') showCartToast(data.product_title || data.title || '');
        if (typeof openCartDrawer === 'function') openCartDrawer();
        if (typeof updateCartCount === 'function') updateCartCount();
        document.dispatchEvent(new CustomEvent('cart-open', { detail: { title: data.product_title || data.title || '' } }));
      })
      .catch(function() {
        btn.disabled = false;
        if (textEl) textEl.textContent = 'Add to Cart';
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;

  var items = nav.querySelectorAll('.header__nav-item');
  items.forEach(function(item, i) { item.style.setProperty('--item-index', i); });

  function openMenu() {
    nav.classList.add('is-open');
    toggle.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    nav.classList.remove('is-open');
    toggle.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function() {
    if (nav.classList.contains('is-open')) { closeMenu(); }
    else { openMenu(); }
  });

  nav.addEventListener('click', function(e) {
    if (e.target === nav || e.target.closest('.header__nav-link')) { closeMenu(); }
  });

  var locs = document.querySelectorAll('[data-localization]');
  locs.forEach(function(locContainer) {
    var locToggle = locContainer.querySelector('[data-localization-toggle]');
    var locDropdown = locContainer.querySelector('[data-localization-dropdown]');
    if (!locToggle || !locDropdown) return;
    locToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      locDropdown.classList.toggle('is-open');
      locToggle.classList.toggle('is-open');
    });
  });
  document.addEventListener('click', function(e) {
    locs.forEach(function(locContainer) {
      if (!locContainer.contains(e.target)) {
        var toggle = locContainer.querySelector('[data-localization-toggle]');
        var dropdown = locContainer.querySelector('[data-localization-dropdown]');
        if (dropdown) dropdown.classList.remove('is-open');
        if (toggle) toggle.classList.remove('is-open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinema"] && !Shopify.designMode) return;
  try {
    
class HeroCinema {
  constructor(el) {
    this.el = el;
    this.slides = el.querySelectorAll('[data-slide]');
    this.dots = el.querySelectorAll('.hero-cinema__slider-dot');
    this.thumbs = el.querySelectorAll('.hero-cinema__thumb');
    this.current = 0;
    this.interval = null;
    this.isPaused = false;

    if (this.slides.length > 1) {
      this.initSlider();
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animate();
          this.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    this.observer.observe(this.el);
  }

  initSlider() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slide)));
    });
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.slide)));
    });
    this.el.addEventListener('mouseenter', () => { this.isPaused = true; });
    this.el.addEventListener('mouseleave', () => { this.isPaused = false; });
    this.startAutoPlay();
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
    this.current = index;
  }

  next() {
    this.goTo((this.current + 1) % this.slides.length);
  }

  startAutoPlay() {
    this.interval = setInterval(() => {
      if (!this.isPaused) this.next();
    }, 4000);
  }

  animate() {
    const items = this.el.querySelectorAll('[class*="hero-cinema__badge"], [class*="hero-cinema__heading"], [class*="hero-cinema__subheading"], [class*="hero-cinema__desc"], [class*="hero-cinema__price"], [class*="hero-cinema__btn"]');
    items.forEach((item, i) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(24px)';
      item.style.transition = `opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${0.15 + i * 0.12}s, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${0.15 + i * 0.12}s`;
      requestAnimationFrame(() => {
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      });
    });

    const frame = this.el.querySelector('.hero-cinema__frame');
    if (frame) {
      frame.style.opacity = '0';
      frame.style.transform = 'scale(0.92)';
      frame.style.transition = 'opacity 1s cubic-bezier(0.22, 1, 0.36, 1) 0.5s, transform 1s cubic-bezier(0.22, 1, 0.36, 1) 0.5s';
      requestAnimationFrame(() => {
        frame.style.opacity = '1';
        frame.style.transform = 'scale(1)';
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-cinema]').forEach((el) => new HeroCinema(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-movie-poster"] && !Shopify.designMode) return;
  try {
    
class HeroCinema {
  constructor(el) {
    this.el = el;
    this.slides = el.querySelectorAll('[data-slide]');
    this.dots = el.querySelectorAll('.hero-cinema__slider-dot');
    this.thumbs = el.querySelectorAll('.hero-cinema__thumb');
    this.current = 0;
    this.interval = null;
    this.isPaused = false;

    if (this.slides.length > 1) {
      this.initSlider();
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animate();
          this.observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    this.observer.observe(this.el);
  }

  initSlider() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.slide)));
    });
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.slide)));
    });
    this.el.addEventListener('mouseenter', () => { this.isPaused = true; });
    this.el.addEventListener('mouseleave', () => { this.isPaused = false; });
    this.startAutoPlay();
  }

  goTo(index) {
    if (index === this.current) return;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
    this.current = index;
  }

  next() {
    this.goTo((this.current + 1) % this.slides.length);
  }

  startAutoPlay() {
    this.interval = setInterval(() => {
      if (!this.isPaused) this.next();
    }, 4000);
  }

  animate() {
    const items = this.el.querySelectorAll('[class*="hero-cinema__badge"], [class*="hero-cinema__heading"], [class*="hero-cinema__subheading"], [class*="hero-cinema__desc"], [class*="hero-cinema__price"], [class*="hero-cinema__btn"]');
    items.forEach((item, i) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(24px)';
      item.style.transition = `opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${0.15 + i * 0.12}s, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${0.15 + i * 0.12}s`;
      requestAnimationFrame(() => {
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      });
    });

    const frame = this.el.querySelector('.hero-cinema__frame');
    if (frame) {
      frame.style.opacity = '0';
      frame.style.transform = 'scale(0.92)';
      frame.style.transition = 'opacity 1s cubic-bezier(0.22, 1, 0.36, 1) 0.5s, transform 1s cubic-bezier(0.22, 1, 0.36, 1) 0.5s';
      requestAnimationFrame(() => {
        frame.style.opacity = '1';
        frame.style.transform = 'scale(1)';
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-cinema]').forEach((el) => new HeroCinema(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var clearBtn = document.querySelector('[data-search-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      var input = document.querySelector('.main-search__input');
      if (input) {
        input.value = '';
        input.focus();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
